import { useState } from 'react';
import './style.css';
import { useLazyQuery} from '@apollo/client';
import { GET_USER_PRIVILEGES } from '../../graphql/liveQuery/queries';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { checkLogin } from '../../api/endPoints/authentication';
import { Slide, ToastContainer, toast } from "react-toastify";
import { useDispatch, useSelector } from 'react-redux';
import { login } from '../../store/authSlice';
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa6";
import moment from 'moment';
import { UseDispatch } from 'react-redux';
import { add } from '@amcharts/amcharts5/.internal/core/util/Time';




const Login = ({ setShowModal }: any) => {

  const [check, setCheck] = useState<boolean>(false);
  const [userDetails, setUserDetails] = useState<any>({
    "userEmail": "",
    "userPassword": ""
  })
  const navigate = useNavigate();
  const dispatch: any = useDispatch();
  const handlePrivacyPolicyClick = () => {
    setShowModal(true);
  };
  // let loginStatus:any 

  const [passwordToggle, setPasswordToggle] = useState<any>(false)

  const notify = (data: any) =>
    toast.success(
      `${data}`,
      {
        position: "top-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
        transition: Slide,
      }
    );


  const [privilegedItem, {}] = useLazyQuery(GET_USER_PRIVILEGES, {
    fetchPolicy: "no-cache",
    onCompleted: (privileges: any) => {
      try {
        return privileges?.privilegedItem;
      } catch (error) {
        console.log("error while fetching from graphql...");
      }
    },
  });


  const handleUserLogin = async (e: any) => {
    e.preventDefault();

    let res: any = await checkLogin({ userId: userDetails['userEmail'], password: userDetails['userPassword'] });
    if ((res?.status === "success") && (check === true)) {
      let getPrivileges: any = await privilegedItem({ variables: { userName: res?.details?.email } });
      let codesArray: any = [];
      (getPrivileges?.data?.privilegedItem)?.map((item: any) => {
        codesArray.push(item.s_code)
      })
      
      let todayDate: any = moment(new Date()).format("YYYY-MM-DD");
      let notificationDetails:any = localStorage.getItem('notification') 
      notificationDetails = localStorage.getItem('notification') ? JSON.parse(notificationDetails) : []

      if((notificationDetails?.length > 0) && (todayDate !== notificationDetails[(notificationDetails?.length) - 1]['date'])) {
        localStorage.setItem('notification', JSON.stringify([]))
      }
      
      let userPrivilegesCode: any = Cookies.get('codesArray');
      let parsedUserPrivilegesCode: any = Cookies.get('codesArray') ? JSON.parse(userPrivilegesCode) : []
      let uniqueUserPrivilegesCode: any = JSON.stringify([...new Set([...codesArray, ...parsedUserPrivilegesCode])]);
      let userDetails: any = JSON.stringify({ ...(res?.details), isLoggedIn: true })

      localStorage.setItem('notificationEnabled', JSON.stringify(res?.details['notification_enabled']))
      localStorage.setItem('theme','light')
      const expiryDate: any = new Date();
      expiryDate.setHours('23', '59', '59');
      let cookieExpiry: any = expiryDate.toUTCString(); // this thing should be fetched from database and then set the expiry
      document.cookie = `details=${userDetails}; expires=${cookieExpiry}; path=/`;
      document.cookie = `codesArray=${uniqueUserPrivilegesCode}; expires=${cookieExpiry}; path=/`;
      dispatch(login())
      navigate('/live')
    }
    else if (res?.attempt_left && res?.status === 'failed') {
      let nofy_message: any = res.message + ' ' + (res?.attempt_left === 'No more login attempts left.' ? 'No more login attempts left.' : res?.attempt_left + 'login attempts left');
      notify(nofy_message)
    }
    else if (res?.status === 'blocked') {
      notify(res?.message)
    }
    else if (res?.status === 'exceed_login_limit') {
      notify(res?.message)
    }
  }
  
  return (
    <>
      <ToastContainer onClick={()=>{toast.dismiss()}}/>
      <div className='content_login'>
        <p className='title'>Welcome To FeedSense</p>
        <div>
          <form className='form'>
            <div className='margin'>
              <input
                type='email'
                className='inputBox'
                name='email'
                placeholder='UserID'
                onChange={(e: any) => { setUserDetails({ ...userDetails, "userEmail": e.target.value }) }}
                required />
            </div>
            <div className='passwordDiv margin'>
              <input
                id='password'
                type={`${!passwordToggle ? 'password' : 'text'}`}
                className='inputBox'
                name='password'
                placeholder='Password'
                onChange={(e: any) => { setUserDetails({ ...userDetails, "userPassword": e.target.value }) }}
                required />
              <span className="password-toggle-icon"><i className="fas fa-eye" onClick={() => setPasswordToggle(!passwordToggle)}> {!passwordToggle ? <FaEye /> : <FaEyeSlash />} </i></span>
            </div>
            <div className='fontSize'>
              <input
                type='checkbox'
                className='checkbox'
                name='checkbox'
                id='checkbox'
                required
                onClick={() => setCheck(check === false ? true : false)}
                onKeyDown={event => {
                  if (event.key === 'Enter') {
                    // setCheck(true);
                    let obj: any = document.getElementById("checkbox");
                    obj.click();
                  }
                }}
                checked={check} />
              I have read and agree to FeedSense terms of use
            </div>
            <div className='marginlogBtn'>
              <input
                type='submit'
                className='loginBtn'
                name='loginBtn'
                value='Login'
                onClick={(e: any) => { handleUserLogin(e) }} />
            </div>
            <div className='line' ></div>
            <div>
              <span className='privacy_policy' onClick={handlePrivacyPolicyClick}>Privacy Policy</span>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default Login;


